<template>
    <el-select
        class="w-100"
        :value="value"
        v-bind:placeholder="placeholder"
        v-bind:clearable="clearable"
        filterable
        remote
        :remote-method="search"
        :loading="loading"
        @change="onChange"
        value-key="id"
    >
        <el-option-group
            v-for="group in options"
            :key="group.label"
            :label="group.label">
            <el-option
                v-for="item in group.items"
                :key="item.id"
                :label="item.label"
                :value="item"
            >
                <div v-if="isContact(item)">
                    <i class="fas fa-user"></i><span class="ml-2">{{ item.label }}</span>
                </div>
                <div v-else>
                    <span>
                        <i class="fas fa-user"></i>
                        <span class="ml-1">{{ item.labelData.contact }}</span>
                    </span>
                    <span class="ml-2">
                        <i class="fas fa-phone-square"></i>
                        <span class="ml-1">{{ item.labelData.outgoingNumber }}</span>
                    </span>
                </div>
            </el-option>
        </el-option-group>
    </el-select>
</template>

<script>
  export default {
    props: {
      url: String,
      value: null,
      placeholder: null,
      clearable: null,
    },

    data() {
      return {
        options: [],
        loading: false,
      };
    },

    methods: {
      search(query) {
        this.loading = true;
        axios.get(this.url, {params: {search: query}})
          .then(({data: {data: groups}}) => {
            this.options = this.prepareOptions(groups);
          })
          .catch(() => {
            this.options = [];
          })
          .finally(() => this.loading = false);
      },

      /**
       * @param {Array} conversations
       * @param {Array} contacts
       */
      prepareOptions({conversations = [], contacts = []}) {
        const result = [];
        if (_.size(conversations)) {
          result.push({
            label: 'Conversations',
            items: this.prepareConversations(conversations),
          });
        }
        if (_.size(contacts)) {
          result.push({
            label: 'Contacts',
            items: this.prepareContacts(contacts),
          });
        }

        return result;
      },

      /**
       * @param {Array} items
       * @return {Array}
       */
      prepareConversations(items) {
        return _.map(items, item => {
          return {
            label: this.formatContact(item.contact) + ' & ' + this.formatOutgoingNumber(item.outgoing_number),
            labelData: this.formatConversation(item),
            type: 'conversation',
            model: item,
            id: `conversation.${item.id}`
          };
        });
      },

      /**
       * @param {Array} items
       * @return {Array}
       */
      prepareContacts(items) {
        return _.map(items, item => {
          return {
            label: this.formatContact(item),
            type: 'contact',
            model: item,
            id: `contact.${item.id}`
          };
        });
      },

      /**
       * @param {Object} item
       * @return {Object}
       */
      formatConversation(item) {
        return {
          contact: this.formatContact(item.contact),
          outgoingNumber: this.formatOutgoingNumber(item.outgoing_number),
        };
      },

      /**
       * @param {string|null} filemaker_id
       * @param {string} phone_number
       * @param {string} full_name
       * @return {string}
       */
      formatContact({filemaker_id, phone_number, full_name}) {
        return String(full_name).trim() + ' (' + String(phone_number).trim() + ')';
      },

      /**
       * @param {string} title
       * @param {string} phone_number
       * @return {string}
       */
      formatOutgoingNumber({title, phone_number}) {
        return title
          ? String(title).trim() + ' (' + String(phone_number).trim() + ')'
          : '(' + String(phone_number).trim() + ')';
      },

      /**
       * @param {Object} item
       * @return {boolean}
       */
      isContact(item) {
        return item.type === 'contact';
      },

      /**
       * @param payload
       */
      onChange(payload) {
        this.$emit('input', payload);
      },

      /**
       * @return {undefined}
       */
      clear() {
        this.$emit('input', null);
        this.options = [];
      },
    },
  }
</script>

